// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");

function pctToNumOfSteps(pct, step) {
  return Caml_int32.div(pct * 100000 | 0, step);
}

function numOfStepsToPct(numOfSteps, step) {
  return Math.imul(numOfSteps, step) / 100000;
}

function progressTrackerMake(step, pctOpt, onProgress, dontDecreaseOpt, param) {
  var pct = pctOpt !== undefined ? pctOpt : 0;
  var dontDecrease = dontDecreaseOpt !== undefined ? dontDecreaseOpt : false;
  var step$1 = step * 100000 | 0;
  var numOfSteps = pctToNumOfSteps(pct, step$1);
  return {
          step: step$1,
          numOfSteps: numOfSteps,
          lastSentNumOfSteps: numOfSteps,
          onProgress: onProgress,
          dontDecrease: dontDecrease
        };
}

function progressTrackerSetCurrPct(state, curPct) {
  var onProgress = state.onProgress;
  if (onProgress === undefined) {
    return state;
  }
  var curNumOfSteps = pctToNumOfSteps(curPct, state.step);
  if (state.dontDecrease && curNumOfSteps > state.lastSentNumOfSteps || !state.dontDecrease && curNumOfSteps !== state.lastSentNumOfSteps) {
    Curry._1(onProgress, numOfStepsToPct(curNumOfSteps, state.step));
    return {
            step: state.step,
            numOfSteps: state.numOfSteps,
            lastSentNumOfSteps: curNumOfSteps,
            onProgress: state.onProgress,
            dontDecrease: state.dontDecrease
          };
  } else {
    return state;
  }
}

exports.progressTrackerMake = progressTrackerMake;
exports.progressTrackerSetCurrPct = progressTrackerSetCurrPct;
/* No side effect */
